import { useEffect } from "react";

const gtmElementId = "gtm-loader-script";

export function useGTMWithEvent(gtmId: string, eventName: string, eventData?: Record<string, any>) {
  useEffect(() => {
    if (!gtmId || !eventName) return;

    // dataLayerの初期化（型エラー回避）
    const w = window as any;
    w.dataLayer = w.dataLayer || [];

    const sendEvent = () => {
      w.dataLayer.push({
        event: eventName,
        ...(eventData || {}),
      });
      console.log(`GTM event '${eventName}' sent`);
    };

    const alreadyLoaded = document.getElementById(gtmElementId);
    if (alreadyLoaded) {
      sendEvent();
      return;
    }

    // GTMスクリプトの読み込み
    w.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    const script = document.createElement("script");
    script.id = gtmElementId;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    script.onload = () => {
      console.log("GTM loaded");
      sendEvent();
    };
    script.onerror = () => {
      console.error("Failed to load GTM");
    };

    document.head.appendChild(script);
  }, [gtmId, eventName, eventData]);
}
